import { IAttrValue } from "@multiweb/types/contracts";
import { AttrValueReader } from "../../../../OW.Remoting/Remoting/AttrValueReader";
import { Enum } from "../../../../OW.Remoting/Remoting/DataTypes/Enums";
import { registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { DefaultEditTemplate } from "../Templates/DataTypeEditTemplates/DefaultEditTemplate";
import { ItemTemplate } from "../Templates/ItemTemplate";
import { Column } from "./Column";

export class EnumColumn extends Column {
    //#region Fields
    //#endregion

    //#region Methods

    public override async formatValue(data: IAttrValue | IAttrValue[]): Promise<string> {
        if (data instanceof Array)
            return "";

        const val = AttrValueReader.read(data);
        if (!(val instanceof Enum))
            return "";

        return await val.getLocalizedName();
    }

    //#endregion Methods

    //#region HTMLElement
    protected override _constructor(): void {
        super._constructor();

        this.itemTemplate = new ItemTemplate();
        this.editItemTemplate = new DefaultEditTemplate();
    }
    //#endregion HTMLElement

    public override dispose(): void {
        super.dispose();
    }
} //end Column

registerCustomElement("tsc-enumcolumn", EnumColumn);
